import { Link } from '@tanstack/react-router';
import { Button, EmptyState, I, Stack } from '@leanin/ui';

export function NotFoundPage() {
  return (
    <Stack align="center" justify="center" py="page" style={{ minHeight: '60vh' }}>
      <EmptyState
        density="page"
        icon={I.search}
        eyebrow="404"
        title="We couldn't find that page"
        body="The link you followed might be broken, or the page may have moved."
        primary={
          <Button variant="primary" href="/feed" linkAs={Link}>
            Go to home
          </Button>
        }
        secondary={
          <Button variant="secondary" href="/directory" linkAs={Link}>
            Browse directory
          </Button>
        }
      />
    </Stack>
  );
}
